import React, { forwardRef } from 'react'
import { styled, Grid as GridBase } from '@mui/material'
import { Download as BaseArrowDownward, Error, Help as HelpIcon } from '@mui/icons-material'
import { Button as BaseButton, Card as BaseCard, Tooltip as TooltipBase } from '@chilecompra/react-kit/components'
import { Link as BaseLink } from 'react-router-dom'

export const GridContainer = styled(props => <GridBase {...props} container />)``

export const ListParticipantsRootArea = styled(props => <GridContainer {...props} />)``

export const GridItem = styled(props => <GridBase {...props} item />)`
  &.MuiGrid-item {
    display: flex;
    flex-direction: ${props => props.flexDirection || 'column'};
    margin: ${props => props.margin || '0'};
    padding: ${props => props.padding || '0'};
  }
`

export const ElementContainer = styled(GridContainer)`
  &.MuiGrid-container {
    border: 1px solid ${props => props.theme.palette.brand.gray2};
    border-radius: 3px;
    flex-grow: 1;
    padding: ${props => props.padding || '32px 24px'};
    ${props => props.theme.breakpoints.down('md')} {
      padding: ${props => props.padding || '17px'};
    }
  }
`

export const ElementContaineItems = styled(GridContainer)`
  &.MuiGrid-container {
    display: block;
  }
`

export const ElementContainerScroll = styled(GridContainer)`
  &.MuiGrid-container {
    height: 343px;
    overflow-y: auto;
  }
`

export const DescriptionTitle = styled('div')`
  color: ${props => props.theme.palette.background.black1};
  font-size: 27px;
  font-style: normal;
  font-weight: 700;
  line-height: 31px;
  padding-top: 15px;
  ${props => props.theme.breakpoints.down('md')} {
    font-size: 22px;
    line-height: 26px;
  }
`

export const DescriptionText = styled(DescriptionTitle)`
  color: ${props => props.theme.palette.brand.black1};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
  padding: 15px 0 24px;
  text-wrap: balance;
  ${props => props.theme.breakpoints.down('lg')} {
    text-wrap: pretty;
  }
`

export const ProcessId = styled('span')`
  color: ${props => props.theme.palette.brand.primary};
  font-size: 27px;
  font-weight: 700;
  line-height: 31px;
  text-align: left;
  ${props => props.theme.breakpoints.down('md')} {
    font-size: 22px;
    line-height: 26px;
  }
`

export const HighLighted = styled('span')`
  font-weight: 700;
  line-height: 21px;
  text-align: left;
`

export const Link = styled(props => <BaseLink {...props} />)`
  color: ${props => props.theme.palette.brand[props.color || 'primary']};
  font-family: ${props => props.theme.typography.fontFamily};
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
  text-align: ${props => props.textAlign || 'left'};
  text-decoration: ${props => props.textDecoration || 'none'};
`

export const DownloadLink = styled(Link)`
  align-items: center;
  display: flex;
  font-size: 14px;
  line-height: 18px;
`

export const ListItem = styled('li')`
  list-style: none;
  &:before {
    font-size: 18px;
    margin-right: 8px;
  }
`

export const ArrowDownwardIcon = styled(BaseArrowDownward)`
  height: 24px;
  margin: 0 4px 0 0;
  width: 24px;

  &:hover {
    color: ${props => props.theme.palette.MP.default.main};
  }
`

export const Button = styled(props => <BaseButton {...props} />)`
  text-wrap: nowrap;
`

export const ErrorContainer = styled(GridBase)`
  border: 1px solid ${props => props.theme.palette.brand.gray2};
  height: 243px;
  margin: 30px 0 0;
  width: 100%;
`

export const ErrorMessageContainer = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  max-width: 600px;
`

export const ErrorIcon = styled(Error)`
  &.MuiSvgIcon-root {
    color: ${props => props.theme.palette.gray[85]};
    height: 70px;
    margin: 0 auto;
    width: 70px;
  }
`

export const AlertIcon = styled('img')`
  height: 48px;
  margin: 0 auto;
  width: 48px;
  ${props => props.theme.breakpoints.down('md')} {
    padding: 0 0 0 15px;
  }
`

export const NoDataIcon = styled('img')`
  width: 65px;
  height: 55px;
`

export const DataTableContainer = styled('div')`
  && .MuiTableRow-root .MuiTableCell-root {
    min-width: 100px;
    white-space: nowrap;
  }
`

export const VerticalFunctionsContainer = styled(GridItem)`
  &.MuiGrid-item {
    display: block;
  }
`

export const Card = styled(BaseCard)`
  &.MuiPaper-root {
    display: flex;

    &.not__found {
      align-items: center;
      justify-content: center;
      min-height: 300px;

      .MuiGrid-container {
        text-align: center;
      }
    }
  }
`

export const NotFoundImg = styled('img')`
  color: ${props => props.theme.palette.gray[50]};
  height: auto;
  pointer-events: none;
  user-select: none;
  width: 64px;
`

export const Tooltip = styled(TooltipBase)`
  &.MuiTooltip-popper .MuiTooltip-tooltip {
    max-height: 100%;
    max-width: 30ch;

    > div {
      line-height: 1.4;
      max-height: 100%;
      word-break: auto-phrase;
    }
  }
`

export const TooltipIcon = styled(forwardRef(({ size, ...props }, ref) => <HelpIcon {...props} ref={ref} />))`
  &.MuiSvgIcon-root {
    fill: ${props => props.theme.palette.brand.black2};
    width: 18px;
    height: 18px;
    margin-left: 6px;
  }
`

export const TooltipText = styled('span')`
  margin: 0;
`
